import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { GetCancelledUsers } from "../../../Api/subscription";
import { ErrorToast } from "../../../Utils/SweetAlert";
import { formatDate } from "../../../Utils/CommanFunctions";
import Tooltip from "@mui/material/Tooltip";


const CancelledUserTab = ({ filters = {}, page = 0, rowsPerPage = 10, onLoaded }) => {
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const apiParams = useMemo(() => ({
        page: page + 1,
        limit: rowsPerPage,
        search: filters?.search || "",
        planType: filters?.planType && filters.planType !== 'all' ? filters.planType : undefined,
        paymentMethod: filters?.paymentMethod && filters.paymentMethod !== 'all' ? filters.paymentMethod : undefined,
        ...(filters?.type ? { type: filters.type } : {}),
        ...(filters?.startDate ? { startDate: filters.startDate } : {}),
        ...(filters?.endDate ? { endDate: filters.endDate } : {}),
        ...(filters?.userId ? { userId: filters.userId } : {}),
    }), [page, rowsPerPage, filters]);

    const fetchCancelledUsers = async () => {
        try {
            setIsLoading(true);
            const response = await GetCancelledUsers(apiParams);
            const payload = response?.data || {};
            setItems(payload?.data || []);
            setTotal(payload?.totalRecords || 0);

            onLoaded && onLoaded({
                total: payload?.totalRecords || 0,
                totals: payload?.totals || null,
            });
        } catch (error) {
            ErrorToast(error?.response?.data?.message || "Failed to fetch cancelled users.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCancelledUsers();
    }, [apiParams]);

    return (
        <div className="cards-table card-table">
            <div className="card-body">
                <div className="table-responsive custom-pagination">
                    <table className="table datatable table-manager mb-0 table-no-padding" style={{ width: '100%', tableLayout: 'fixed' }}>
                        <thead className="thead-light">
                            <tr>
                                <th className="text-start" style={{ width: '25%' }}>Name</th>
                                <th className="text-start" style={{ width: '30%' }}>Email</th>
                                <th className="text-start" style={{ width: '15%' }}>Plan Type</th>
                                <th className="text-start" style={{ width: '10%' }}>Start Date</th>
                                <th className="text-start" style={{ width: '10%' }}>End Date</th>
                                <th className="text-start" style={{ width: '10%' }}>Method</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading && (
                                <tr>
                                    <td align="center" colSpan={6}>
                                        <div className="d-flex justify-content-center align-items-center py-4">
                                            <div className="spinner-border loader-theme" role="status" />
                                        </div>
                                    </td>
                                </tr>
                            )}
                            {!isLoading && items?.length === 0 && (
                                <tr>
                                    <td className="text-center" colSpan={6}>No Records Found.</td>
                                </tr>
                            )}
                            {!isLoading && items?.map((row) => (
                                <tr key={row?._id}>
                                    <td className="text-start">
                                        <Tooltip title={row?.name || '-'} placement="top" arrow>
                                            <span className="user-cell-ellipsis">
                                                {row?._id ? (
                                                    <Link className="subscription-neutral-link" to="/admin/client-user-detail" state={{ id: row?._id }}>
                                                        {row?.name || '-'}
                                                    </Link>
                                                ) : (row?.name || '-')}
                                            </span>
                                        </Tooltip>
                                    </td>
                                    <td className="text-start">
                                        <Tooltip title={row?.email || '-'} placement="top" arrow>
                                            <span className="user-cell-ellipsis">
                                                {row?.email || '-'}
                                            </span>
                                        </Tooltip>
                                    </td>
                                    <td className="text-capitalize">{row?.planType || '-'}</td>
                                    <td className="text-start">{formatDate(row?.startDate)}</td>
                                    <td className="text-start">{formatDate(row?.endDate)}</td>
                                    <td className="text-capitalize">
                                        {row?.subscription?.paymentMethod === "cash" ? "Manual (cash)" :
                                            row?.subscription?.paymentMethod === "stripe" ? "Stripe" :
                                                row?.subscription?.paymentMethod === "apple_pay" ? "Apple Pay" :
                                                    row?.subscription?.paymentMethod === "google_play" ? "Google Play" :
                                                        "Stripe"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default CancelledUserTab;
